export default {
  fringesItems: [],
};
